module.exports = __webpack_public_path__ + "static/media/mshtml_32548.93c908dd.ico";